import { render, staticRenderFns } from "./progress-icon.vue?vue&type=template&id=4dea23cb&scoped=true&"
import script from "./progress-icon.vue?vue&type=script&lang=js&"
export * from "./progress-icon.vue?vue&type=script&lang=js&"
import style0 from "./progress-icon.vue?vue&type=style&index=0&id=4dea23cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dea23cb",
  null
  
)

export default component.exports